import React, { useState, useContext, useEffect } from 'react';
import { Form, Button, Input, InputNumber, Select, Tooltip, Icon, DatePicker, Switch, Collapse, Steps, notification } from 'antd';
import GlobalStateContext from '../../../../context'
import TextArea from 'antd/lib/input/TextArea';
import StreamWebService from '../../../../classes/StreamWebService';
import { withRouter } from 'react-router-dom';
import { protectedRoutesPrefix } from '../../../../routers/routes';
import Rider from '../../../../components/Rider';
import FileUpload from '../../../../components/FileUpload';
import { _notification, canIUse, canUserCreateStream } from '../../../../utils';
import { isMobile } from 'react-device-detect';
import SelectStreamSource from './SelectStreamSource';
import Greetings from '../../../../components/Greetings';
import FeatureNotAccessible from './FeatureNotAccessible';
import { STREAM_SOURCE_URL } from '../../../../constants';
import { v4 as uuid } from 'uuid';

const CreateStream = function (props) {

  const { onClose, type, item, onSave } = props;
  const { getFieldDecorator, setFieldsValue } = props.form;
  const [types, setTypes] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [isPublic, setIsPublic] = useState(!!item ? item.is_public : true);
  const [isLoading, setLoading] = useState(false);
  const [usdEquiv, setUSDEquiv] = useState(0.00);
  const [imageUploadState, setImageUploadState] = useState({});

  const [isDefaultCurreny, setisDefaultCurreny] = useState(true);
  const [state, dispatch] = useContext(GlobalStateContext);
  const { eventCategories, configuration, features_accessible, streams } = state;
  const { Option } = Select
  const [activeStep, setactiveStep] = useState(0)
  const [source, setSource] = useState(item?.source)
  const [resource_id, setResourcId] = useState(item?.resource_id)
  // const resource_id = item?.resource_id || uuid();

  const catOptions = eventCategories.map(d => <Option key={d}>{d}</Option>);

  const fetchTypes = async () => {
    try {
      const webservice = new StreamWebService();
      webservice.getStreamsTypes()
        .then(res => res.data)
        .then(types => setTypes(types));
    } catch (error) {
      _notification.error("Failed to fetch types");
    }
  }

  const featchDestinations = async () => {
    try {
      const webservice = new StreamWebService();
      webservice.getDestinations()
        .then(res => res.data)
        .then(dest => setDestinations(dest));
    } catch (error) {
      _notification.error("Failed to fetch destinations");
    }
  }


  const cleanUp = () => {
    onClose && (onClose());
    props.form.resetFields()
  }


  useEffect(() => {
    fetchTypes();
    featchDestinations();
    setResourcId(item?.resource_id || uuid());
    // setisDefaultCurreny(state.currency.code == "USD")
    return cleanUp;
  }, [])

  useEffect(() => {
    setUSDEquiv((item?.ppv_value * state.xrate) || 0.00)
    setisDefaultCurreny(state.currency.code == "USD")

  }, [item])
  useEffect(() => {
    setisDefaultCurreny(state.currency.code == "USD")
  }, [state.currency])

  const onFileUploadComplete = (info) => {
    console.log("onFileUploadComplete", info)
    setImageUploadState(info);
    setFieldsValue({ image: info.file.response.data.key })
  }

  const onSubmit = (e) => {
    e.preventDefault();

    props.form.validateFields(async (err, values) => {


      console.log(values);

      if (!err) {

        values.type = type;
        values.user = state.user.id;
        values.resource_id = resource_id;
        values.upload_data = { image: imageUploadState?.file?.response?.data }

        if (!isDefaultCurreny) {
          values.ppv_value = values.ppv_value ? parseFloat(values.ppv_value / state.xrate).toFixed(2) : 0.00;
        }
        setLoading(true);
        console.log(values);
        const service = new StreamWebService();
        await service
          .save({ data: values, id: item ? item.id : null })
          .then(resp => {
            props.form.resetFields();
            onClose && (onClose());
            // _notification.success("Stream saved successfully");
            //Navigate to the details page
            const dt = resp.data

            if (onSave) {
              console.log("is save")
              return onSave(dt)
            }
            const path = `/${protectedRoutesPrefix}/events`
            props.history.push(path)
          })
          .catch(err => {
            const msg = err.response ? err.response.data.message : err.message
            notification.error({ message: `Could not save. ${msg}` });
          }).finally(_ => {
            setLoading(false);
          });


      } else {
        console.log(Object.entries(err))
        Object.entries(err).forEach(error => error[1].errors.forEach(msg => { notification.error({ message: msg.message, placement: "topRight" }) }))
      }
    })
  }

  const onSourceSelect = (data) => {
    console.log(data)
    setactiveStep(activeStep + 1)
    setFieldsValue({ source: data })
    setSource(data)
  }

  const onStepSwitch = (step) => {
    setactiveStep(step)
  }


  const Step1 = (
    <div className='col-md-12 col-sm-12'>
      <Greetings title={"Video Source "} description="Where are you taking the video input from?" />

      <div className='m-t-20'>
        {/* Properly wrap the SelectStreamSource component within JSX */}
        {getFieldDecorator('source', {
          rules: [{ required: true, message: "Select a video source" }],
          initialValue: item?.source,
          validateTrigger: 'onBlur'
        })(
          <SelectStreamSource onSelect={onSourceSelect} stream={item} />
        )}
      </div>
    </div>
  );


  const Step2 = (
    <>
      <div className="space-y-2" id="streamTitle">
        <label className="text-sm font-semibold text-gray-700 flex items-center">
          Event Title <span className="text-red-500 ml-1">*</span>
        </label>
        <Form.Item>
          {getFieldDecorator('title', {
            rules: [{ required: true, min: 6, message: 'Title is required and must be at least 6 characters' }],
            initialValue: item ? item.title : "",
            validateTrigger: 'onBlur'
          })(
            <Input 
              size="large"
              placeholder="Annual Music Festival and Awards"
              className="rounded-lg"
            />
          )}
        </Form.Item>
      </div>
      <div className="space-y-2" id="streamDescription">
        <label className="text-sm font-semibold text-gray-700 flex items-center">
          Description <span className="text-red-500 ml-1">*</span>
        </label>
        <Form.Item>
          {getFieldDecorator('description', {
            initialValue: item ? item.description : "",
            rules: [{ required: true, min: 6, message: 'Please enter description and #tags' }],
          })(
            <TextArea 
              rows={4}
              placeholder="A ceremony to the world! #worldfest #funtime"
              className="rounded-lg"
            />
          )}
        </Form.Item>
      </div>

      {source !== STREAM_SOURCE_URL && (
        <div className="space-y-2">
          <label className="text-sm font-semibold text-gray-700 flex items-center">
            Start Date 
            <span className="text-gray-400 text-xs font-normal ml-2">(optional)</span>
          </label>
          <Form.Item>
            {getFieldDecorator('starts_at', {
              defaultValue: !!item ? item.starts_at : null
            })(
              <DatePicker 
                size="large"
                className='w-full rounded-lg'
                showTime={true}
                placeholder="Select date and time"
                format="YYYY-MM-DD HH:mm"
                style={{ borderColor: '#d1d5db' }}
              />
            )}
          </Form.Item>
          <div className="text-xs text-gray-500 flex items-center">
            Leave empty to go live immediately when ready
          </div>
        </div>
      )}

      {source == STREAM_SOURCE_URL && (
        <div className="space-y-2" id="videoUrl">
          <label className="text-sm font-semibold text-gray-700 flex items-center">
            Stream URL <span className="text-red-500 ml-1">*</span>
          </label>
          <Form.Item>
            {getFieldDecorator('url', {
              rules: [{ required: true, min: 6, message: 'External link. eg https://myvideourl.m3u8' }],
              initialValue: item ? item.url : "",
              validateTrigger: 'onBlur'
            })(
              <Input 
                size="large"
                placeholder="https://myvideourl.m3u8"
                className="rounded-lg"
              />
            )}
          </Form.Item>
          <div className="text-xs text-gray-500 flex items-center">
            Enter the direct URL to your video stream (HLS, RTMP, etc.)
          </div>
        </div>
      )}
      <div className="space-y-2" id="streamCategory">
        <label className="text-sm font-semibold text-gray-700 flex items-center">
          Category 
          <span className="text-gray-400 text-xs font-normal ml-2">(optional)</span>
        </label>
        <Form.Item>
          {getFieldDecorator('category', {
            initialValue: item ? item.category : [],
            rules: [{ required: false, message: 'Specify category' }],
            validateTrigger: 'onBlur'
          })(
            <Select
              size="large"
              mode="tag"
              className='rounded-lg'
              showSearch
              placeholder="Add categories like 'sports', 'music', 'education'..."
              defaultActiveFirstOption={false}
              showArrow={true}
              filterOption={true}
              notFoundContent={null}
              style={{ minHeight: '40px' }}
            >
              {catOptions}
            </Select>
          )}
        </Form.Item>
        <div className="text-xs text-gray-500 flex items-center">
          Add relevant tags to help viewers discover your content
        </div>
      </div>
      <div className="space-y-2" id="streamBanner">
        <label className="text-sm font-semibold text-gray-700 flex items-center">
          Cover Image
          <span className="text-gray-400 text-xs font-normal ml-2">(recommended)</span>
        </label>
        <Form.Item>
          {getFieldDecorator('image', {
            rules: [],
          })(
            <FileUpload
              data={{ resource_id: item?.resource_id ?? resource_id, bucket: "vod-viblica" }}
              text={'Event Image'}
              preview={true}
              onComplete={onFileUploadComplete}
            />
          )}
        </Form.Item>
        <div className="text-xs text-gray-500 flex items-center">
          Upload an eye-catching cover image (16:9 ratio recommended)
        </div>
      </div>
      <div className="space-y-2" id="streamVisibility">
        <label className="text-sm font-semibold text-gray-700 flex items-center">
          Visibility
        </label>
        <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg border">
          <Form.Item className="mb-0">
            {getFieldDecorator('is_public', {
              checked: isPublic
            })(
              <Switch
                size="default"
                checkedChildren={<><Icon type="check" /> Public</>}
                unCheckedChildren={<><Icon type="lock" /> Private</>}
                checked={isPublic}
                defaultChecked={isPublic}
                onChange={_ => setIsPublic(_)}
              />
            )}
          </Form.Item>
          <div className="flex-1">
            <div className="text-sm font-medium text-gray-700">
              {isPublic ? 'Public Event' : 'Private Event'}
            </div>
            <div className="text-xs text-gray-500">
              {isPublic 
                ? 'Anyone can discover and watch this event' 
                : 'Only people with the link can access this event'
              }
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <Collapse 
          bordered={false} 
          className="bg-white rounded-lg border"
          expandIconPosition="right"
        >
          <Collapse.Panel 
            key={1} 
            header={
              <div className="flex items-center">
                <span className="font-semibold">Paywall</span>
                <span className="text-xs text-gray-500 ml-2">Set a price for your event</span>
              </div>
            }
          >

            {(configuration.enable_ppv === '1' && canIUse('paywall', features_accessible)) &&

              <div className="">
                <label
                  className="block text-gray-700 font-bold mb-2"
                  htmlFor="eventTitle"
                >
                  Paywall
                </label>
                <Form.Item

                                    help={`Amount you expect viewers to pay before watching your event.
                ${!isDefaultCurreny ?
                                        `Please note that this amount will be converted to USD at a rate of ${state.currency.symbol} ${state.xrate}` : ""

                                      }
                `}
                >
                  {getFieldDecorator('ppv_value', {
                    rulses: [{ min: 0.00, message: 'Amount cannot be lower than 0.00' }],

                    initialValue: !!item ? (!!item && item.ppv_value * state.xrate) : 0.00,
                    validateTrigger: 'onBlur'
                  })(<InputNumber min={0.00} placeholder={`${state.currency.symbol} 2.00`} onChange={valu => setUSDEquiv(parseFloat(valu / state.xrate).toFixed(2))} />)}
                  {
                    state.currency.code != "USD"
                    &&
                    <> &cong; <InputNumber disabled value={`$ ${usdEquiv} `} /></>
                  }
                </Form.Item>
              </div>
            }




          </Collapse.Panel>
          <Collapse.Panel 
            key={2} 
            header={
              <div className="flex items-center">
                <span className="font-semibold">Donation</span>
                <span className="text-xs text-gray-500 ml-2">Allow voluntary contributions</span>
              </div>
            }
          >

            {(configuration.enable_ppv === '1' && canIUse('donation', features_accessible)) &&

              <div className="">
                <label
                  className="block text-gray-700 font-bold mb-2"
                  htmlFor="eventTitle"
                >
                  Donation
                </label>
                <Form.Item

                                    help={`Amount you expect viewers to pay before watching your event.
                ${!isDefaultCurreny ?
                                        `Please note that this amount will be converted to USD at a rate of ${state.currency.symbol} ${state.xrate}` : ""

                                      }
                `}
                >
                  {getFieldDecorator('ppv_value', {
                    rulses: [{ min: 0.00, message: 'Amount cannot be lower than 0.00' }],

                    initialValue: !!item ? (!!item && item.ppv_value * state.xrate) : 0.00,
                    validateTrigger: 'onBlur'
                  })(<InputNumber min={0.00} placeholder={`${state.currency.symbol} 2.00`} onChange={valu => setUSDEquiv(parseFloat(valu / state.xrate).toFixed(2))} />)}
                  {
                    state.currency.code != "USD"
                    &&
                    <> &cong; <InputNumber disabled value={`$ ${usdEquiv} `} /></>
                  }
                </Form.Item>
              </div>
            }




          </Collapse.Panel>
        </Collapse>
        
        <Collapse 
          bordered={false} 
          className="bg-white rounded-lg border"
          expandIconPosition="right"
        >
          <Collapse.Panel 
            key={3} 
            header={
              <div className="flex items-center">
                <span className="font-semibold">Social Media</span>
                <span className="text-xs text-gray-500 ml-2">Connect your social accounts</span>
              </div>
            }
          >

           

              <div className="space-y-4 p-4">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700 flex items-center">
                    Facebook
                  </label>
                  <Form.Item>
                    {getFieldDecorator('socials[facebook]', {
                      rules: [],
                      initialValue: item?.socials?.facebook ?? null,
                      validateTrigger: 'onBlur'
                    })(
                      <Input 
                        size="large"
                        placeholder="https://facebook.com/your-event-page"
                        className="rounded-lg"
                      />
                    )}
                  </Form.Item>
                </div>
                
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700 flex items-center">
                    Twitter/X
                  </label>
                  <Form.Item>
                    {getFieldDecorator('socials[twitter]', {
                      rules: [],
                      initialValue: item?.socials?.twitter ?? null,
                      validateTrigger: 'onBlur'
                    })(
                      <Input 
                        size="large"
                        placeholder="@your_event_handle"
                        className="rounded-lg"
                      />
                    )}
                  </Form.Item>
                </div>
              </div>
           




          </Collapse.Panel>
        </Collapse>
      </div>

      <div className="flex gap-4 mt-8 pt-6 border-t border-gray-200">
        {activeStep > 0 && (
          <Button 
            size='large' 
            className='flex-1 h-12 rounded-lg border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 font-medium'
            onClick={() => setactiveStep(activeStep - 1)}
            icon={<Icon type="left" />}
          >
            Previous
          </Button>
        )}

        <Button 
          size='large' 
          loading={isLoading} 
          disabled={isLoading} 
          type="primary" 
          className={`${activeStep === 0 ? 'w-full' : 'flex-1'} h-12 rounded-lg bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 font-semibold text-white shadow-md hover:shadow-lg transition-all duration-200 disabled:bg-blue-400 disabled:border-blue-400`}
          onClick={onSubmit}
          icon={<Icon type={item?.id ? "edit" : "plus"} />}
        >
          {isLoading 
            ? (item?.id ? "Updating..." : "Creating...") 
            : (item?.id ? "Update Event" : "Create Event")
          }
        </Button>
      </div>




    </>)



  const steps = [
    {
      title: "Source",
      content: Step1
    },
    {
      title: "Details",
      content: Step2
    }
  ]

  return (

    <>

      <Rider steps={state.introSteps.createStreamForm} />

      <div id="createStreamForm" className='flex flex-col' >
        {/* {!isMobile && <Steps type="navigation" onChange={onStepSwitch} current={activeStep} direction='horizontal'>
          {steps.map(step => {

            return <Steps.Step key={step.title} title={step.title} />
          }
          )}

        </Steps>} */}

        <div className="steps-content">
          <Form layout="vertical" hideRequiredMark className='space-y-6' >
            {
              steps.map((step, index) => (
                <div key={index} hidden={activeStep != index} className="space-y-6"> 
                  {step.content} 
                </div>
              ))
            }
          </Form>
        </div>


        <div className="m-t-20">
          {/* <Button key="cancel_button" onClick={onClose} style={{ marginRight: 8 }}>
          Cancel
            </Button> */}


        </div>

       


      </div >

    </>
  )
}

export default withRouter(Form.create()(CreateStream));